<template>
  <MainLayout v-if="isAuthenticated">
    <slot />
  </MainLayout>
  <PublicLayout v-else>
    <slot />
  </PublicLayout>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import MainLayout from './MainLayout.vue'
import PublicLayout from './PublicLayout.vue'
import { useAuthStore } from '../stores/authStore'

@Options({
  components: {
    MainLayout,
    PublicLayout
  },
})
export default class ConditionalLayout extends Vue {
  isAuthenticated = false;

  async mounted() {
    try {
      const { checkAuth } = useAuthStore();
      const authData = await checkAuth();
      this.isAuthenticated = authData.isAuthenticated;
    } catch (error) {
      this.isAuthenticated = false;
    }
  }
}
</script> 